/**
 * Überschreibt den {@code basePath} des generierten BIC-Backend-Clients ({@code BASE_PATH}).
 *
 * <p>{@code null}: es gilt der Wert, den {@code api-client-generation*.sh} in die Services
 * geschrieben hat. Die Serve-Konfiguration {@code beta} ersetzt diese Datei durch
 * {@code api-base-path.beta.ts}.
 */
export const API_BASE_PATH: string | null = null;
